import type {
  TestInfoStartFontSchemaType,
  TestInfoStartSchemaType,
} from '@vedalib/editor/lib/brand'
import type { FileImageUsage } from '@vedalib/editor/lib/files'
import { FileUsageTypeEnum } from '@vedalib/editor/lib/files'
import cn from 'classnames'

import type { ElementFontCss, ElementStyleCss } from 'services/Branding/types'
import { useUrlByUsage } from 'utils/files'
import { testProps } from 'utils/test/qaData'

import { getUrlMedia } from '../../utils/getUrlImage'
import * as s from './TestInfoItem.module.scss'
import './TestInfoItem.scss'

type TestInfoItemProps = {
  item?: string
  text?: string
  icon?: React.FC<React.SVGProps<SVGSVGElement>> | null
  show: boolean
  testInfoItemVariable?: string
  image: Omit<FileImageUsage, 'type'> | null
  styles: ElementStyleCss<TestInfoStartSchemaType>
  font?: ElementFontCss<TestInfoStartFontSchemaType>
}

const TestInfoItem = ({
  item,
  text,
  icon,
  show,
  testInfoItemVariable,
  image: imageProps,
  styles,
  font,
}: TestInfoItemProps) => {
  const Icon = icon || null

  const imageUrl = useUrlByUsage(imageProps, FileUsageTypeEnum.image)
  // const customImage = image?.path || imageProps?.url

  return (
    <li key={item}>
      <div
        className={cn(`test-info-item test-info-item--isVisible--${show}`)}
        {...testProps({ el: 'testInfoItem', name: item, val: testInfoItemVariable })}
      >
        {imageUrl && (
          <div className={s.item}>
            <img
              alt='test status'
              className='test-info-item__img'
              src={getUrlMedia(imageProps, imageUrl)}
              style={{ ...styles.circle, ...styles.effects, objectFit: imageProps?.objectFit }}
            />
          </div>
        )}
        {!imageUrl && Icon && (
          <div className='test-info-item__icon' style={{ ...styles.circle, ...styles.effects }}>
            <Icon aria-hidden />
          </div>
        )}

        <span className='test-info-item__text' style={font?.base}>
          {text} - {testInfoItemVariable}
        </span>
      </div>
    </li>
  )
}

export { TestInfoItem }
